/* eslint-disable quotes */
import escape from 'lodash-es/escape';

const impressions_sent = [];
const sendProductImpression = (variant, product, inventory, containerClass) => {
  if (impressions_sent.indexOf(variant.barcode) > -1) {
    return;
  }
  impressions_sent.push(variant.barcode);

  const country = window.theme.country_iso;
  const quadpay_country = country === `US`;

  const active_price = variant.price;
  const active_compare_at_price = product.compare_at_price;

  // If customer navigates in PDP, i.e: https://store.com/collections/dresses/products/something we can assign collectionName
  let collectionName = window.theme.collection || window.theme.collectionName || '';
  const hasBreadCrumbLinks = document.querySelector('.Breadcrumb__link>a:last-child');

  if (!collectionName && hasBreadCrumbLinks) {
    // It's helpful in two possible scenarios
    // 1. In case customer was redirected from a Quick View and ended up clicking Product Title link there
    // 2. if customer is navigating in PDP like https://store.com/products/something
    collectionName = hasBreadCrumbLinks.textContent || '';
  }

  // Only if Quick View is open
  if (containerClass.trim() === 'QuickView__content') {
    collectionName = hasBreadCrumbLinks.textContent || '';
  }

  console.log('28 collectionName', collectionName);
  const admind_product = {
    id: product.id,
    style: escape(variant.barcode),
    subcategory: escape(product.type),
    name: escape(product.title.replace(/((CLEARANCE)|(PLACEHOLDER))( - )/, '')),
    price: active_price,
    originalPrice: active_compare_at_price,
    newArrival: product.tags.includes('New Arrival'),
    isMarkedDown: Number(active_price) < Number(active_compare_at_price),
    showsQuadpay: quadpay_country && Number(active_price) > 14,
    // list: `Product`,
    position: 1,
    almostGone: inventory ? Number(inventory[variant.id]) < 10 : false,
    hasReviews: false,
    reviewCount: 0,
    reviewAverage: 0,
    list: collectionName || '',
  };

  const dataLayer = window.dataLayer || [];
  let dataLayerTimeout = 0;
  clearTimeout(dataLayerTimeout);
  // Defer dataLayer push
  dataLayerTimeout = setTimeout(
    () =>
      dataLayer.push({
        event: `impressions`,
        ecommerce: {
          impressions: {
            products: [admind_product],
          },
        },
      }),
    250,
  );
};

export { sendProductImpression };
